<script lang="ts" module>
  export const verifyEmailModal = new ModalQueryState('verify-email');
</script>

<script lang="ts">
  import ArrowLeft from '~icons/mdi/arrow-left';
  import Close from '~icons/mdi/close';
  import Send from '~icons/mdi/send';

  import ActionButton from '~/components/ActionButton.svelte';
  import Modal from '~/components/Modal.svelte';
  import { resendEmailMutation, type FormInputEvent } from './mutations.svelte';
  import { validateEmail } from './utils';
  import { ModalQueryState } from '~/lib/nav.svelte';
  import ValidationError from './ValidationError.svelte';

  const resendEmail = resendEmailMutation();
  const email = $derived(verifyEmailModal.value);
  const error = $derived(email === 'error');
  // svelte-ignore state_referenced_locally
  let newEmail = $state(error ? '' : (email ?? ''));
  let validationError = $state<string>();

  const handleClose = () => {
    verifyEmailModal.pop();
    // again to dismiss signup
    history.back();
  };

  const handleBack = () => {
    verifyEmailModal.pop();
  };

  const handleBlur = async (e: FormInputEvent) => {
    if (newEmail.length) {
      validationError = validateEmail(newEmail);
    }
  };

  const handleResend = (e: SubmitEvent) => {
    e.preventDefault();
    resendEmail.mutate(newEmail);
    verifyEmailModal.replace(newEmail);
  };
</script>

<Modal open={verifyEmailModal.open} onClose={handleClose} index={8}>
  {#snippet title()}
    {#if error}
      Invalid Link
    {:else}
      Verify Email
    {/if}
  {/snippet}
  {#snippet content()}
    <div class="content">
      {#if error}
        <p>This link is invalid or has expired. Try sending a new email.</p>
      {:else}
        <p>
          Please click the verification link in the email sent to <b>{email}</b>
          to verify your account. It may take up to 5 minutes for this email to arrive.
        </p>
        <h3>Didn't get it?</h3>
        <p>resend confirmation email</p>
      {/if}
      <form id="resend-email-form" class="auth-form" onsubmit={handleResend}>
        <input
          bind:value={newEmail}
          type="email"
          name="email"
          placeholder="email"
          required
          onblur={handleBlur}
        />
        <ValidationError error={validationError} />
      </form>
    </div>
  {/snippet}
  {#snippet controls()}
    <ActionButton onClick={handleClose}><Close />CLOSE</ActionButton>
    <ActionButton onClick={handleBack}><ArrowLeft />BACK</ActionButton>
    <ActionButton
      type="submit"
      form="resend-email-form"
      disabled={!(resendEmail.isIdle || resendEmail.isSuccess) ||
        !!validationError ||
        !newEmail}
    >
      <Send />
      {#if resendEmail.isPending}
        Sending...
      {:else if resendEmail.isSuccess}
        Sent!
      {:else}
        Resend
      {/if}
    </ActionButton>
  {/snippet}
</Modal>

<style lang="scss">
  @use '~/theme/theme.scss';
  @use 'sass:color';

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    p {
      text-align: center;
    }
    input {
      width: 100%;
      max-width: 24em;
    }
  }
</style>
